import React from 'react'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

const navCss = css`
  /** Height of subnav + border-bottom */
  height: 53px;
  background: ${colors.gray00};
  border-bottom: 1px solid ${colors.gray10};
`

export default function SubnavLoading() {
  return <nav css={navCss} />
}
